import { BiFile } from "react-icons/bi";
import {
  IoDocumentTextOutline,
  IoEnterOutline,
  IoFileTrayStackedOutline,
  IoPeopleOutline,
  IoPersonOutline,
  IoReceiptOutline,
  IoMailOutline,
  IoBarChartOutline,
  IoSettingsOutline
} from "react-icons/io5";
import { PAGES } from "duck/constants";
import { UserRoleEnum } from "requests";
import { MenuItem } from "./types";

export const getMenu = (isOnline: boolean, userRole: UserRoleEnum) =>
  userRole === UserRoleEnum.RoleSuperAdmin
    ? [
        {
          key: PAGES.management,
          to: "/organization-management",
          icon: IoPeopleOutline
        },
        {
          key: PAGES.licenseManagement,
          to: "/license-management",
          icon: IoDocumentTextOutline
        },
        {
          key: PAGES.orderManagement,
          to: "/order-management",
          icon: IoReceiptOutline
        },
        {
          key: PAGES.reports,
          to: "/reports",
          icon: IoBarChartOutline
        },
        {
          key: PAGES.accessLogs,
          to: "/access-logs",
          icon: IoEnterOutline
        },
        {
          key: PAGES.emailLogs,
          to: "/email-logs",
          icon: IoMailOutline
        }
      ]
    : ([
        {
          key: PAGES.cases,
          to: "/cases",
          icon: IoFileTrayStackedOutline
        },
        isOnline && {
          key: PAGES.protocols,
          to: "/anesthetic-protocols",
          icon: BiFile
        },
        isOnline &&
          userRole === UserRoleEnum.RoleOrganizationAdmin && {
            key: PAGES.management,
            to: "/organization-management",
            icon: IoPeopleOutline
          },
        isOnline &&
          userRole !== UserRoleEnum.RoleOrganizationAdmin && {
            key: PAGES.profile,
            to: "/profile",
            icon: IoPersonOutline
          },
        isOnline &&
          userRole === UserRoleEnum.RoleOrganizationAdmin && {
            key: PAGES.settings,
            to: "/settings",
            icon: IoSettingsOutline
          }
      ].filter(Boolean) as MenuItem[]);
